// extracted by mini-css-extract-plugin
export default {"root":"components__blocks__rendered-service__teeth-select-menu__root"};